import { defineComponent } from 'vue'

// import BaseResource, { VendorResource, PurchaseOrderResource, AccountResource } from '@sigmacloud/sigma-client/dist/resources'
import { AddressResource, StateResource, CityResource } from '@sigmacloud/sigma-client/dist/resources'
import AgGridColumnMethodMixins from './AgGridColumnMethods'

/*
* AG Grid Column Defs here
*/
export default defineComponent({
  mixins: [AgGridColumnMethodMixins],

  data () {
    return {
      vendorNumberColumn: {
        headerName: 'Vendor #',
        field: 'vendorNumber',
        colId: 'vendorNumber',
        maxWidth: 120,
        minWidth: 50,
        editable: false,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.code || ''
        },
        valueSetter: () => null
      },
      vendorNameColumn: {
        headerName: 'Name',
        field: 'vendorName',
        colId: 'vendorName',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.name || ''
        },
        valueSetter: () => null
      },
      vendorStatusColumn: {
        headerName: 'Status',
        field: 'vendorStatus',
        colId: 'vendorStatus',
        maxWidth: 100,
        minWidth: 50,
        editable: false,
        sortable: true,
        menuTabs: [],
        valueFormatter: (params) => {
          if (params.value === true || params.value === 'true') {
            return 'Active'
          } else {
            return 'Not Approved'
          }
        },
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.active || ''
        },
        valueSetter: () => null
      },
      vendorTypeColumn: {
        headerName: 'Type',
        field: 'entity_type',
        colId: 'entity_type',
        maxWidth: 170,
        minWidth: 100,
        // eslint-disable-next-line
        // editable: () => this.isVendorEditable ? true : false,
        editable: true,
        cellClass: 'editable',
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.entity_type || ''
        },
        valueSetter: (params) => {
          if (params.data) params.data.set('entity_type', params.newValue) // This is the important one
          params.data.save()
          this.$emit('vendorUpdated', { vendor: params.data, field: 'entity_type', key: 'vendor_type' })
        },
        cellEditor: 'agRichSelectCellEditor',
        cellEditorParams: {
          values: [ 'NOT_1099', 'CORPORATION', 'LLC', 'LLC_CORP', 'LEGAL_FIRM', 'PARTNERSHIP', 'SOLE_PROPRIETOR_SSN', 'SOLE_PROPRIETOR_EIN', 'INDIVIDUAL', 'OTHER', 'UNKNOWN' ]
        }
      },
      vendorPayeeNameColumn: {
        headerName: 'Payee Name',
        field: 'vendorPayeeName',
        colId: 'vendorPayeeName',
        maxWidth: 300,
        minWidth: 200,
        editable: false,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.payee_name || ''
        },
        valueSetter: () => null
      },
      vendorTaxIdColumn: {
        headerName: 'Tax ID',
        field: 'tax_id',
        colId: 'tax_id',
        maxWidth: 100,
        minWidth: 80,
        // eslint-disable-next-line
        // editable: () => this.isVendorEditable ? true : false,
        editable: true,
        cellClass: 'editable',
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.tax_id || ''
        },
        valueSetter: (params) => {
          if (params.data) params.data.set('tax_id', params.newValue) // This is the important one
          params.data.save()
        }
      },
      vendorOpenPosColumn: {
        headerName: 'Open POs?',
        field: 'vendorOpenPos',
        colId: 'vendorOpenPos',
        maxWidth: 110,
        minWidth: 90,
        editable: false,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.open_pos || ''
        },
        valueSetter: () => null
      },
      vendorDescriptionColumn: {
        headerName: 'Description',
        field: 'description',
        colId: 'description',
        maxWidth: 500,
        minWidth: 250,
        editable: false,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.description || ''
        },
        valueSetter: () => null
      },
      /*
      NumberColumn: {
        headerName: 'Number',
        field: 'number',
        colId: 'number',
        maxWidth: 150,
        minWidth: 100,
        editable: false,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.number || ''
        },
        valueSetter: () => null
      },
      */
      taxableVendorTypeColumn: {
        headerName: 'Type',
        field: 'entity_type',
        colId: 'entity_type',
        maxWidth: 170,
        minWidth: 100,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.entity_type || ''
        },
        valueSetter: (params) => {
          if (params.data) params.data.set('entity_type', params.newValue) // This is the important one
        },
        cellEditor: 'agRichSelectCellEditor',
        cellEditorParams: {
          values: [ 'NOT_1099', 'CORPORATION', 'LLC', 'LLC_CORP', 'LEGAL_FIRM', 'PARTNERSHIP', 'SOLE_PROPRIETOR_SSN', 'SOLE_PROPRIETOR_EIN', 'INDIVIDUAL', 'OTHER', 'UNKNOWN' ]
        }
      },
      taxableVendorTaxIdColumn: {
        headerName: 'Tax ID',
        field: 'tax_id',
        colId: 'tax_id',
        maxWidth: 100,
        minWidth: 80,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          return resource.attributes.tax_id || ''
        },
        valueSetter: (params) => {
          if (params.data) params.data.set('tax_id', params.newValue) // This is the important one
        }
      },
      vendorAddress1Column: {
        headerName: 'Address 1',
        field: 'address_1',
        colId: 'address_1',
        maxWidth: 200,
        minWidth: 160,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          if (resource && resource.attributes && resource.attributes.newAddress && resource.attributes.newAddress.line1) {
            // Temp address
            return resource.attributes.newAddress.line1 || ''
          } else if (resource && resource.attributes.address_selected && resource.attributes.address_selected.id) {
            const cachedAddress = AddressResource.getCached(resource.attributes.address_selected.id)
            if (cachedAddress) {
              return cachedAddress.resource.attributes.line1 || ''
            }
          } else {
            return '(none)' // means there is no address
          }
        },
        valueSetter: async (params) => {
          let resource = params.data
          // Addresses cannot be patched anymore. Must create new address. But need to make sure all required fields are valid before creating by saving into a temp address
          if (!resource.attributes.newAddress) resource.attributes.newAddress = {}
          resource.attributes.newAddress.line1 = params.newValue
          console.log(resource.attributes.newAddress.line1)

          const existingAddress = (resource && resource.attributes && resource.attributes.address_selected) ? resource.attributes.address_selected : {}
          let newAddressResource = await this.createNewAddress(resource.attributes.newAddress, existingAddress)
          if (newAddressResource && newAddressResource.id) {
            resource.set('default_address', 'CONTACT')
            resource.set('address_contact_id', newAddressResource.id)
            resource.set('address_selected_id', newAddressResource.id)
            resource.attributes.newAddress = undefined
            await resource.save()
          } else {
            // keep collecting data
          }
        }
      },
      vendorAddress2Column: {
        headerName: 'Address 2',
        field: 'address_2',
        colId: 'address_2',
        maxWidth: 100,
        minWidth: 50,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          if (resource && resource.attributes && resource.attributes.newAddress && resource.attributes.newAddress.line2) {
            // Temp address
            return resource.attributes.newAddress.line2 || ''
          } else if (resource && resource.attributes.address_selected && resource.attributes.address_selected.id) {
            const cachedAddress = AddressResource.getCached(resource.attributes.address_selected.id)
            if (cachedAddress) {
              return cachedAddress.resource.attributes.line2 || ''
            }
          } else {
            return ''
          }
        },
        valueSetter: async (params) => {
          let resource = params.data
          // Addresses cannot be patched anymore. Must create new address. But need to make sure all required fields are valid before creating by saving into a temp address
          if (!resource.attributes.newAddress) resource.attributes.newAddress = {}
          resource.attributes.newAddress.line2 = params.newValue
          console.log(resource.attributes.newAddress.line2)

          const existingAddress = (resource && resource.attributes && resource.attributes.address_selected) ? resource.attributes.address_selected : {}
          let newAddressResource = await this.createNewAddress(resource.attributes.newAddress, existingAddress)
          if (newAddressResource && newAddressResource.id) {
            resource.set('default_address', 'CONTACT')
            resource.set('address_contact_id', newAddressResource.id)
            resource.set('address_selected_id', newAddressResource.id)
            resource.attributes.newAddress = undefined
            await resource.save()
          } else {
            // keep collecting data
          }
        }
      },
      vendorCityColumn: {
        headerName: 'City',
        field: 'city',
        colId: 'city',
        maxWidth: 150,
        minWidth: 80,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          if (resource && resource.attributes && resource.attributes.newAddress && resource.attributes.newAddress.city) {
            // Temp address
            return isNaN(resource.attributes.newAddress.city) ? resource.attributes.newAddress.city : StateResource.getCached(resource.attributes.newAddress.city).resource.attributes.name
          } else if (resource && resource.attributes.address_selected && resource.attributes.address_selected.id) {
            let cityId = (((AddressResource.getCached(resource.attributes.address_selected.id) || {}).resource || {}).attributes || {}).city
            const cachedCity = cityId ? ((CityResource.getCached(cityId) || {}).resource || {}).attributes || {} : {}
            return cachedCity.name || ''
          }
        },
        valueSetter: async (params) => {
          let resource = params.data
          // Addresses cannot be patched anymore. Must create new address. But need to make sure all required fields are valid before creating by saving into a temp address
          if (!resource.attributes.newAddress) resource.attributes.newAddress = {}
          resource.attributes.newAddress.city = params.newValue
          console.log(resource.attributes.newAddress.city)

          const existingAddress = (resource && resource.attributes && resource.attributes.address_selected) ? resource.attributes.address_selected : {}
          let newAddressResource = await this.createNewAddress(resource.attributes.newAddress, existingAddress)
          if (newAddressResource && newAddressResource.id) {
            resource.set('default_address', 'CONTACT')
            resource.set('address_contact_id', newAddressResource.id)
            resource.set('address_selected_id', newAddressResource.id)
            resource.attributes.newAddress = undefined
            await resource.save()
          } else {
            // keep collecting data
          }
        }
      },
      vendorStateColumn: {
        headerName: 'State',
        field: 'state',
        colId: 'state',
        maxWidth: 70,
        minWidth: 50,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          if (resource && resource.attributes && resource.attributes.newAddress && resource.attributes.newAddress.state) {
            // Temp address
            return resource.attributes.newAddress.state ? StateResource.getCached(resource.attributes.newAddress.state).resource.attributes.code : ''
          } else if (resource && resource.attributes.address_selected && resource.attributes.address_selected.id) {
            let stateId = (((AddressResource.getCached(resource.attributes.address_selected.id) || {}).resource || {}).attributes || {}).state
            const cachedState = stateId ? ((StateResource.getCached(stateId) || {}).resource || {}).attributes || {} : {}
            return cachedState.code || ''
          }
        },
        valueSetter: async (params) => {
          let resource = params.data
          // Addresses cannot be patched anymore. Must create new address. But need to make sure all required fields are valid before creating by saving into a temp address
          if (!resource.attributes.newAddress) resource.attributes.newAddress = {}
          resource.attributes.newAddress.state = params.newValue.id // This is the important one
          console.log(resource.attributes.newAddress.state)

          const existingAddress = (resource && resource.attributes && resource.attributes.address_selected) ? resource.attributes.address_selected : {}
          let newAddressResource = await this.createNewAddress(resource.attributes.newAddress, existingAddress)
          if (newAddressResource && newAddressResource.id) {
            resource.set('default_address', 'CONTACT')
            resource.set('address_contact_id', newAddressResource.id)
            resource.set('address_selected_id', newAddressResource.id)
            resource.attributes.newAddress = undefined
            await resource.save()
          } else {
            // keep collecting data
          }
        },
        cellEditor: 'gridAutocomplete',
        cellEditorParams: {
          options: {
            resourceClass: StateResource
            // updateLineResource: true // this effectively replaces valueSetter.  Needed to handle setting data asynchronously.
          }
        }
      },
      vendorPostalColumn: {
        headerName: 'Zip',
        field: 'postal',
        colId: 'postal',
        maxWidth: 60,
        minWidth: 60,
        editable: true,
        sortable: true,
        menuTabs: [],
        valueGetter: (params) => {
          let resource = params.data
          if (resource && resource.attributes && resource.attributes.newAddress && resource.attributes.newAddress.postal) {
            // Temp address
            return resource.attributes.newAddress.postal || ''
          } else if (resource && resource.attributes.address_selected && resource.attributes.address_selected.id) {
            const cachedAddress = AddressResource.getCached(resource.attributes.address_selected.id)
            if (cachedAddress) {
              return cachedAddress.resource.attributes.postal
            }
          } else {
            return ''
          }
        },
        valueSetter: async (params) => {
          let resource = params.data
          // Addresses cannot be patched anymore. Must create new address. But need to make sure all required fields are valid before creating by saving into a temp address
          if (!resource.attributes.newAddress) resource.attributes.newAddress = {}
          resource.attributes.newAddress.postal = params.newValue
          console.log(resource.attributes.newAddress.postal)

          const existingAddress = (resource && resource.attributes && resource.attributes.address_selected) ? resource.attributes.address_selected : {}
          let newAddressResource = await this.createNewAddress(resource.attributes.newAddress, existingAddress)
          if (newAddressResource && newAddressResource.id) {
            resource.set('default_address', 'CONTACT')
            resource.set('address_contact_id', newAddressResource.id)
            resource.set('address_selected_id', newAddressResource.id)
            resource.attributes.newAddress = undefined
            await resource.save()
          } else {
            // keep collecting data
          }
        }
      }
    }
  }
})
